import ColumnComponent from './Column.vue';
export const Column = ColumnComponent;
export default Column;
